import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import moment from "moment";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

import Breadcrumbs from "components/Common/Breadcrumb";
import { getSchemeAnalytesList } from "store/results/actions";
import { getResultSubmit } from "store/resultsSubmit/actions";
// import { getMicroStatisticsList } from "store/results/actions";
// import { updateRoundList } from "store/rounds/actions";
import "assets/scss/table.scss";

class SummaryResults extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      showModal: false,
      modalTitle: "",
      modalLabs: [],
      SchemeAnalytesList: [],
      buttonText: "Calculate",
      ResultSubmit: [],
      Statistics: [],
      antibiotic: "",
      Antibiotic: [],
      microStats: [],
      antibioticValue: 0,
      combinedData: [], // Store the combined data here
      // analyte: "",
      // rounds: [],
      isCalculated: false, // Flag to track calculation status
      successMessage: "",
      modal: false, // Modal state for visibility control
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      organismColumns: [
        {
          text: "Organism",
          dataField: "organism",
          sort: true,
          headerStyle: () => ({
            textAlign: "center",
          }),
          align: "left",
        },
        {
          text: "Submitted Labs",
          dataField: "organism_count",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#f8d7da", // full red header
            textAlign: "center",
          }),
          style: {
            backgroundColor: "#f8d7da", // ✅ same background for cells
            textAlign: "center",
          },
          align: "center",
          formatter: (cell, row) => {
            if (cell === 0) return "--";
            return (
              <Button
                color="link"
                onClick={() =>
                  this.handleOpenModal(
                    "Submitted Labs",
                    row.participant_names || []
                  )
                }
              >
                {cell}
              </Button>
            );
          },
        },
      ],

      antibioticColumns: [
        {
          text: "Antibiotic",
          dataField: "antibiotic",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#a6d4ff", // full blue header
            textAlign: "center",
          }),
          align: "left",
        },
        {
          text: "Submitted Labs",
          dataField: "submitted_labs",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#a6d4ff", // header background
            textAlign: "center",
          }),
          style: {
            // <-- object, not function
            backgroundColor: "#a6d4ff", // cell background
            textAlign: "center",
          },
          align: "center",
          formatter: (cell) => (cell === 0 ? "--" : cell),
        },
        {
          text: "Resistant",
          dataField: "resistant_labs",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#f8d7da", // full red header
            textAlign: "center",
          }),
          style: () => ({
            backgroundColor: "#a6d4ff", // cell background
            textAlign: "center",
          }),
          align: "center",

          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Resistant Labs",
                  row.resistant_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
        {
          text: "Sensitive",
          dataField: "sensitive_labs",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#d4edda", // full green header
            textAlign: "center",
          }),
          style: () => ({
            backgroundColor: "#a6d4ff", // cell background
            textAlign: "center",
          }),
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Sensitive Labs",
                  row.sensitive_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
        {
          text: "Intermediate",
          dataField: "intermediate_labs",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#fff3cd", // full yellow header
            textAlign: "center",
          }),
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Intermediate Labs",
                  row.intermediate_labs_list || []
                )
              }
            >
              {cell}
            </Button>
          ),
        },
        {
          text: "Not Tested",
          dataField: "not_tested_labs",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#e2e3e5", // full grey header
            textAlign: "center",
          }),
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Not Tested Labs",
                  row.not_tested_labs_list || []
                )
              }
            >
              {cell}
            </Button>
          ),
        },
      ],

      antibioticColumns: [
        {
          text: "Antibiotic",
          dataField: "antibiotic",
          sort: true,
          headerStyle: { textAlign: "center" },
          align: "left",
        },
        {
          text: "Submitted Labs",
          dataField: "submitted_labs",
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          style: { backgroundColor: "#a6d4ff", textAlign: "center" }, // ✅ fixed
          align: "center",
          formatter: (cell) => (cell === 0 ? "--" : cell),
        },
        {
          text: "Resistant",
          dataField: "resistant_labs",
          sort: true,
          headerStyle: { backgroundColor: "#f8d7da", textAlign: "center" },
          style: { backgroundColor: "#f8d7da", textAlign: "center" }, // ✅ fixed
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Resistant Labs",
                  row.resistant_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
        {
          text: "Sensitive",
          dataField: "sensitive_labs",
          sort: true,
          headerStyle: { backgroundColor: "#d4edda", textAlign: "center" },
          style: { backgroundColor: "#d4edda", textAlign: "center" }, // ✅ fixed
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Sensitive Labs",
                  row.sensitive_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
        {
          text: "Intermediate",
          dataField: "intermediate_labs",
          sort: true,
          headerStyle: { backgroundColor: "#fff3cd", textAlign: "center" },
          style: { backgroundColor: "#fff3cd", textAlign: "center" }, // ✅ fixed
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Intermediate Labs",
                  row.intermediate_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
        {
          text: "Not Tested",
          dataField: "not_tested_labs",
          sort: true,
          headerStyle: { backgroundColor: "#e2e3e5", textAlign: "center" },
          style: { backgroundColor: "#e2e3e5", textAlign: "center" }, // ✅ fixed
          align: "center",
          formatter: (cell, row) => (
            <Button
              color="link"
              onClick={() =>
                this.handleOpenModal(
                  "Not Tested Labs",
                  row.not_tested_labs_list || []
                )
              }
            >
              {cell === 0 ? "--" : cell}
            </Button>
          ),
        },
      ],
    };
  }
  combineData = (analytes, results) => {
    return analytes.map((analyte) => {
      const resultEntry = results.find(
        (result) => result.analyte === analyte.id
      );
      console.log("MATCHED ENTRY FOR:", analyte.name, resultEntry); // ✅ add this
      return {
        ...analyte,
        lab_count: resultEntry?.lab_count || 0,
        correct: resultEntry?.correct || 0,
        wrong: resultEntry?.wrong || 0,
        not_submitted: resultEntry?.not_submitted || 0,
      };
    });
  };

  isAllFieldsZero = (data) => {
    // Check if all the relevant fields in the data are equal to 0
    return data.every(
      (item) =>
        item.lab_count === 0 &&
        item.correct === 0 &&
        item.wrong === 0 &&
        item.not_submitted === 0
    );
  };

  componentDidMount() {
    const { onGetSchemeAnalyte } = this.props;
    const id = this.props.match.params.id;

    console.log("🔵 componentDidMount -> Round ID:", id);

    // ✅ Always fetch scheme analytes
    console.log("📥 Fetching SchemeAnalytes...");
    onGetSchemeAnalyte(id);
  }

  componentDidUpdate(prevProps) {
    const { Statistics, AntibioticStatistics } = this.props;

    // Organism stats
    if (Statistics !== prevProps.Statistics && !isEmpty(Statistics)) {
      console.log(
        "🟡 componentDidUpdate -> Organism Statistics changed:",
        Statistics
      );

      const organismRows = Statistics.map((row, idx) => ({
        id: idx + 1,
        ...row,
      }));
      this.setState({ organismStats: organismRows });
    }

    if (
      AntibioticStatistics !== prevProps.AntibioticStatistics &&
      !isEmpty(AntibioticStatistics)
    ) {
      console.log("🔬 Antibiotic Stats Payload:", AntibioticStatistics);

      const antibioticRows = AntibioticStatistics.map((row, idx) => ({
        id: idx + 1,
        antibiotic: row.antibiotic || row.name || `Antibiotic ${idx + 1}`,
        submitted_labs: row.submitted_labs || row.total_participants || 0,
        resistant_labs: row.resistant_labs || 0,
        sensitive_labs: row.sensitive_labs || 0,
        intermediate_labs: row.intermediate_labs || 0,
        not_tested_labs: row.not_tested_labs || 0,
        resistant_labs_list: row.resistant_labs_list || [],
        sensitive_labs_list: row.sensitive_labs_list || [],
        intermediate_labs_list: row.intermediate_labs_list || [],
        not_tested_labs_list: row.not_tested_labs_list || [],
      }));

      this.setState({ antibioticStats: antibioticRows });
    }
  }

  handleOpenModal = (title, labs) => {
    this.setState({
      showModal: true,
      modalTitle: title,
      modalLabs: labs,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, modalTitle: "", modalLabs: [] });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  render() {
    // };
    const {
      closing_date,
      rounds,
      scheme_name,
      scheme_type,
      cycle_no,
      round_issuedate,
      round_status,
    } = this.props;

    const { combinedData } = this.state; // Use the combined data
    const pageOptions = {
      sizePerPage: 10,
      totalSize: combinedData.length, // Adjust totalSize for combined data
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "desc",
      },
    ];
    // const microStats = this.props.Statistics?.statistics || [];
    const microStats = this.state.microStats || [];

    const { issue_date } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Statistics | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Row className="mb-3">
              <Col className="text-start">
                <Button
                  color="primary"
                  onClick={() => this.props.history.goBack()}
                >
                  ← Back
                </Button>
              </Col>
            </Row>
            {/* Modal for displaying success message */}
            <Modal isOpen={this.state.showModal} toggle={this.handleCloseModal}>
              <ModalHeader toggle={this.handleCloseModal}>
                {this.state.modalTitle}
              </ModalHeader>
              <ModalBody>
                {this.state.modalLabs.length > 0 ? (
                  <ul>
                    {this.state.modalLabs.map((lab, i) => (
                      <li key={i}>{lab}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No labs found.</p>
                )}
              </ModalBody>
            </Modal>

            <div className="container">
              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Round:</span>
                    <span>
                      <strong>{rounds ? rounds : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Name:</span>
                    <span>
                      <strong>{scheme_name ? scheme_name : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Type:</span>
                    <span>
                      <strong>{scheme_type ? scheme_type : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Cycle No:</span>
                    <span>
                      <strong>{cycle_no ? cycle_no : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Closing Date:</span>
                    <span>
                      <strong>
                        {closing_date
                          ? moment(closing_date).format("DD-MMM-YY, h:mm A")
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Issued Date:</span>
                    <span>
                      <strong>
                        {round_issuedate
                          ? moment(round_issuedate).format(
                              "DD-MMM-YY, h:mm A"
                            )
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Status:</span>
                    <span>
                      <strong>{round_status ? round_status : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <Modal isOpen={this.state.showModal} toggle={this.handleCloseModal}>
              <ModalHeader toggle={this.handleCloseModal}>
                {this.state.modalTitle}
              </ModalHeader>
              <ModalBody>
                {this.state.modalLabs.length > 0 ? (
                  <ul>
                    {this.state.modalLabs.map((lab, i) => (
                      <li key={i}>{lab}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No labs found.</p>
                )}
              </ModalBody>
            </Modal>

            <Row className="justify-content-center">
              {/* Organism Table */}
              <Col xs="12" sm="12" md="12" lg="9">
                <Card>
                  <CardBody>
                    <h5>Organism Table</h5>
                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.organismColumns}
                      data={this.state.organismStats || []}
                      search
                    >
                      {(toolkitProps) => (
                        <BootstrapTable {...toolkitProps.baseProps} />
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>

              {/* Antibiotic Table */}
              <Col xs="12" sm="12" md="12" lg="9">
                <Card>
                  <CardBody>
                    <h5>Antibiotic Table</h5>
                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.antibioticColumns}
                      data={this.state.antibioticStats || []}
                      search
                    >
                      {(toolkitProps) => (
                        <BootstrapTable {...toolkitProps.baseProps} />
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

SummaryResults.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  SchemeAnalytesList: PropTypes.array,
  ResultSubmit: PropTypes.array,
  Statistics: PropTypes.array,
  AntibioticStatistics: PropTypes.array,
  rounds: PropTypes.string,
  issue_date: PropTypes.object,
  scheme_name: PropTypes.string,
  scheme_type: PropTypes.string,
  rounds: PropTypes.string,
  closing_date: PropTypes.string,
  round_issuedate: PropTypes.string,
  round_status: PropTypes.string,
  cycle_no: PropTypes.string,
  ListAntibiotic: PropTypes.array,
  // closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetResultSubmit: PropTypes.func,
  history: PropTypes.object.isRequired,
};
const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  ResultSubmit: ResultSubmit.ResultSubmit,

  // ✅ Statistics is inside SchemeAnalytesList reducer
  Statistics: SchemeAnalytesList.Statistics,
  IdentificationResults: SchemeAnalytesList.IdentificationResults, // if you added this
  AntibioticStatistics: SchemeAnalytesList.AntibioticStatistics,

  rounds: SchemeAnalytesList.rounds,
  rounds_instance: SchemeAnalytesList.rounds_instance,
  closing_date: SchemeAnalytesList.closing_date,

  scheme_name: SchemeAnalytesList.schemeName,
  scheme_type: SchemeAnalytesList.schemeType,
  round_issuedate: SchemeAnalytesList.issue_date,
  round_status: SchemeAnalytesList.round_status,
  cycle_no: SchemeAnalytesList.cycle_no,
});

const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onGetResultSubmit: (id) => dispatch(getResultSubmit(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SummaryResults));
